jQuery( document ).ready( function() {
	let department = '';
	function updateThePermalink() {
		if ( history.pushState ) {
			let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			if ( department !== '' ) {
				oldurl += `?department=${ department }`;
			}
			window.history.pushState( { path: oldurl }, '', oldurl );
		}
	}
	function ReIntilizeHoverEffect() {
		jQuery( '.member-tab' ).on( 'mouseover', function() {
			jQuery( '.member-image' ).removeClass( 'active' );
			jQuery( '.member-tab' ).removeClass( 'active_location' );
			jQuery( this ).addClass( 'active_location' );
			jQuery( '.member-image[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
		} );

		jQuery( '.location__pin' ).on( 'mouseover', function() {
			jQuery( '.location-single' ).removeClass( 'active' );
			jQuery( '.location__pin' ).removeClass( 'active_location' );
			jQuery( this ).addClass( 'active_location' );
			jQuery( '.location-single[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
		} );
	}

	jQuery( '.ajax-department' ).on( 'click', function() {
		 jQuery( '.ajax-department' ).removeClass( 'current' );
		jQuery( this ).addClass( 'current' );
		department = jQuery( this ).data( 'slug' );
		// console.log( department );
		sendAjaxRequest();
		updateThePermalink();
	} );

	function sendAjaxRequest() {
		jQuery( '.lds-roller' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
			    action: 'deparment_post_filter',
				department,
			    },
			success( response ) {
				if ( response ) {
					// console.log( response.html );
					// console.log( response.args );
					// console.log( response.image );
					jQuery( '#team-members' ).empty();
					jQuery( '#team-members' ).html( response.html );
					jQuery( '#ajax-category-image' ).empty();
					jQuery( '#ajax-category-image' ).html( response.image );
					jQuery( '.lds-roller' ).hide();
				}
				ReIntilizeHoverEffect();
			},
		} );
	}
} );
